'use-strict';

/* @ngInject */
export default function LoginScreenController(
  $scope,
  $location,
  loginService,
  interfaceService,
) {
  $scope.error = null;
  $scope.sending = false;

  $scope.login = () => {
    $scope.sending = true;
    loginService.login($scope.email, $scope.password)
      .then((path) => $location.path(path))
      .catch((e) => {
        $scope.sending = false;
        console.error(e);
        $scope.error = e.message;
        interfaceService.applyScope($scope);
      });
  };
}
